import apiClient from "../../api/axiosInstance";
import { STATUS, extractErrorInfo } from "./sharedfunction";

/**
 * Record ToS + Privacy acceptance for the authenticated user.
 * @param {{ tosLegalDocumentVersionId: string, privacyLegalDocumentVersionId: string }} params
 */
export async function recordUserConsent({
  tosLegalDocumentVersionId,
  privacyLegalDocumentVersionId,
} = {}) {
  try {
    if (!tosLegalDocumentVersionId || !privacyLegalDocumentVersionId) {
      return {
        status: STATUS.ERROR,
        error: "Legal document version IDs are required",
        code: "LEGAL_DOCUMENT_VERSION_IDS_REQUIRED",
      };
    }

    const response = await apiClient.post("/user/consent", {
      tos_legal_document_version_id: tosLegalDocumentVersionId,
      privacy_legal_document_version_id: privacyLegalDocumentVersionId,
    });

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data ?? {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message ?? response?.data?.error,
      code: response?.data?.code,
    };
  } catch (error) {
    return extractErrorInfo(error);
  }
}
